import { datadogRum } from '@datadog/browser-rum';
import { version } from '../../../package.json';
const EXCLUDED_RUM_URL_PARTS = [
    '/_sf/api/v1/auth_tokens.json',
    '/components-standalone',
    'https://image-manager.sourceflow.co.uk/api/v1/images'
];
const isExcludedRumUrl = (url)=>EXCLUDED_RUM_URL_PARTS.some((part)=>url?.includes(part));
if (process.env.NODE_ENV === 'production') {
    const applicationId = 'e59dab6b-54a0-4842-8a0c-3e6f92a620d8';
    const clientToken = 'pub4860a2654abe343de22f58e7388a84ff';
    const sessionSampleRate = 25; // Capture 25% of sessions for RUM
    const sessionReplaySampleRate = 5; // Capture 5% of sessions for Session Replay
    const trackResources = true; // Enable resource tracking
    const trackUserInteractions = true; // Enable user interaction tracking
    const trackLongTasks = true; // Enable long task tracking
    console.log('Initializing Datadog RUM with configuration:', {
        applicationId,
        clientToken,
        site: 'datadoghq.eu',
        service: 'sourceflow-cms-frontend',
        env: process.env.NODE_ENV === 'production' ? 'production' : 'development',
        version,
        sessionSampleRate,
        sessionReplaySampleRate,
        trackResources,
        trackUserInteractions,
        trackLongTasks
    });
    datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.eu',
        service: 'sourceflow-cms-frontend',
        env: process.env.NODE_ENV === 'production' ? 'production' : 'development',
        version,
        sessionSampleRate,
        sessionReplaySampleRate,
        trackResources,
        trackUserInteractions,
        trackLongTasks,
        // ----- Recommended Options -----
        // Do not forget to upload your debug symbols to get deobfuscated stack traces, read {docs} to learn how to
        allowedTracingUrls: [
            window.location.origin
        ],
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: (event, context)=>{
            const viewUrl = event.view?.url || context.location?.href || window.location.href;
            const resourceUrl = event.type === 'resource' ? event.resource?.url : '';
            return !isExcludedRumUrl(viewUrl) && !isExcludedRumUrl(resourceUrl);
        }
    });
}
